import React from "react";
import InputField from "../FormElement/InputField/InputField";
import SelectField from "../FormElement/SelectField/SelectField";
import PhoneField from "../FormElement/PhoneField/PhoneField";

const FormConstructor = ({ events, field }) => {
  switch (field.type) {
    case "text":
    case "email":
      return <InputField {...events} {...field} />;
    case "select":
      return <SelectField {...events} {...field} />;
    case "phone":
      return <PhoneField {...events} {...field} />;
    default:
      return;
  }
};

export default FormConstructor;
